module.exports = {
  prefix: '',
  important: true,
  separator: ':',
  theme: {
    screens: {
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1200px',
    },
    colors: {
      transparent: 'transparent',

      black: '#000',
      white: '#fff',

      grey: {
        default: '#a4a4a4',
        100: '#f8f8f8',
        200: '#e8e8e8',
        300: '#dbdbdb',
        400: '#bfbfbf',
        500: '#a4a4a4',
        600: '#949494',
        700: '#626262',
        800: '#4a4a4a',
        900: '#313131',
      },
      red: {
        default: '#d8534f',
        100: '#fbeeed',
        200: '#f5d4d3',
        300: '#efbab9',
        400: '#e48784',
        500: '#d8534f',
        600: '#c24b47',
        700: '#82322f',
        800: '#612524',
        900: '#411918',
      },
      danger: {
        default: '#d8534f',
        100: '#fbeeed',
        200: '#f5d4d3',
        300: '#efbab9',
        400: '#e48784',
        500: '#d8534f',
        600: '#c24b47',
        700: '#82322f',
        800: '#612524',
        900: '#411918',
      },
      orange: {
        default: '#d67550',
        100: '#fbf1ee',
        200: '#f5ddd3',
        300: '#efc8b9',
        400: '#e29e85',
        500: '#d67550',
        600: '#c16948',
        700: '#804630',
        800: '#603524',
        900: '#402318',
      },
      yellow: {
        default: '#ffdd58',
        100: '#fffcee',
        200: '#fff7d5',
        300: '#fff1bc',
        400: '#ffe78a',
        500: '#ffdd58',
        600: '#e6c74f',
        700: '#998535',
        800: '#736328',
        900: '#4d421a',
      },
      warning: {
        default: '#ffdd58',
        100: '#fffcee',
        200: '#fff7d5',
        300: '#fff1bc',
        400: '#ffe78a',
        500: '#ffdd58',
        600: '#e6c74f',
        700: '#998535',
        800: '#736328',
        900: '#4d421a',
      },
      green: {
        default: '#00ce7d',
        100: '#e6faf2',
        200: '#bff3df',
        300: '#99ebcb',
        400: '#4ddda4',
        500: '#00ce7d',
        600: '#00b971',
        700: '#007c4b',
        800: '#005d38',
        900: '#003e26',
      },
      success: {
        default: '#00ce7d',
        100: '#E6FAF2',
        200: '#BFF3DF',
        300: '#99EBCB',
        400: '#4DDDA4',
        500: '#00CE7D',
        600: '#00B971',
        700: '#007C4B',
        800: '#005D38',
        900: '#003E26',
      },
      teal: {
        default: '#20c997',
        100: '#e9faf5',
        200: '#c7f2e5',
        300: '#a6e9d5',
        400: '#63d9b6',
        500: '#20c997',
        600: '#1db588',
        700: '#13795b',
        800: '#0e5a44',
        900: '#0a3c2d',
      },
      'cyan': {
        default: '#44a4dc',
        100: '#ecf6fc',
        200: '#d0e8f6',
        300: '#b4dbf1',
        400: '#7cbfe7',
        500: '#44a4dc',
        600: '#3d94c6',
        700: '#296284',
        800: '#1f4a63',
        900: '#143142',
      },
      'info': {
        default: '#44a4dc',
        100: '#ecf6fc',
        200: '#d0e8f6',
        300: '#b4dbf1',
        400: '#7cbfe7',
        500: '#44a4dc',
        600: '#3d94c6',
        700: '#296284',
        800: '#1f4a63',
        900: '#143142',
      },
      blue: {
        default: '#0769ba',
        100: '#e6f0f8',
        200: '#c1daee',
        300: '#9cc3e3',
        400: '#5196cf',
        450: '#237ec7',
        500: '#0769ba',
        600: '#065fa7',
        700: '#043f70',
        800: '#032f54',
        900: '#022038',
      },
      primary: {
        default: '#0769ba',
        100: '#e6f0f8',
        200: '#c1daee',
        300: '#9cc3e3',
        400: '#5196cf',
        500: '#0769ba',
        600: '#065fa7',
        700: '#043f70',
        800: '#032f54',
        900: '#022038',
      },
      indigo: {
        default: '#6666cc',
        100: '#f0f0fa',
        200: '#d9d9f2',
        300: '#c2c2eb',
        400: '#9494db',
        500: '#6666cc',
        600: '#5c5cb8',
        700: '#3d3d7a',
        800: '#2e2e5c',
        900: '#1f1f3d',
      },
      purple: {
        default: '#9966cc',
        100: '#f5f0fa',
        200: '#e6d9f2',
        300: '#d6c2eb',
        400: '#b894db',
        500: '#9966cc',
        600: '#8a5cb8',
        700: '#5c3d7a',
        800: '#452e5c',
        900: '#2e1f3d',
      },
      pink: {
        default: '#e83e8c',
        100: '#fdecf4',
        200: '#f9cfe2',
        300: '#f6b2d1',
        400: '#ef78af',
        500: '#e83e8c',
        600: '#d1387e',
        700: '#8b2554',
        800: '#681c3f',
        900: '#46132a',
      },
    },
    spacing: {
      px: '1px',
      '0': '0',
      '1': '0.25rem',
      '2': '0.5rem',
      '3': '0.75rem',
      '4': '1rem',
      '5': '1.25rem',
      '6': '1.5rem',
      '8': '2rem',
      '10': '2.5rem',
      '12': '3rem',
      '16': '4rem',
      '20': '5rem',
      '24': '6rem',
      '32': '8rem',
      '40': '10rem',
      '48': '12rem',
      '56': '14rem',
      '64': '16rem',
      '96': '24rem',
      '112': '28rem',
      '128': '32rem',
    },
    backgroundColor: theme => theme('colors'),
    backgroundPosition: {
      bottom: 'bottom',
      center: 'center',
      left: 'left',
      'left-bottom': 'left bottom',
      'left-top': 'left top',
      right: 'right',
      'right-bottom': 'right bottom',
      'right-top': 'right top',
      top: 'top',
    },
    backgroundSize: {
      auto: 'auto',
      cover: 'cover',
      contain: 'contain',
    },
    borderColor: theme => ({
      ...theme('colors'),
      default: theme('colors.gray.300', 'currentColor'),
    }),
    borderRadius: {
      none: '0',
      sm: '0.125rem',
      default: '0.25rem',
      lg: '0.5rem',
      full: '9999px',
    },
    borderWidth: {
      default: '1px',
      '0': '0',
      '2': '2px',
      '4': '4px',
      '8': '8px',
    },
    boxShadow: {
      default: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      'md-dark': '0px 2px 5px #999',
      lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
      inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
      outline: '0 0 0 3px rgba(66, 153, 225, 0.5)',
      none: 'none',

      'sau-lg': '1px 1px 12px 2px rgba(0, 0, 0, 0.1)',
    },
    container: {},
    cursor: {
      auto: 'auto',
      default: 'default',
      pointer: 'pointer',
      wait: 'wait',
      text: 'text',
      move: 'move',
      'not-allowed': 'not-allowed',
    },
    fill: {
      current: 'currentColor',
    },
    flex: {
      '1': '1 1 0%',
      auto: '1 1 auto',
      initial: '0 1 auto',
      none: 'none',
    },
    flexGrow: {
      '0': '0',
      default: '1',
    },
    flexShrink: {
      '0': '0',
      default: '1',
    },
    fontFamily: {
      sans: [
        'sau-roboto-light',
        'Arial',
        'Helvetica',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        '"Noto Sans"',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"',
      ],
      serif: [
        'Georgia',
        'Cambria',
        '"Times New Roman"',
        'Times',
        'serif',
      ],
      mono: [
        'Menlo',
        'Monaco',
        'Consolas',
        '"Liberation Mono"',
        '"Courier New"',
        'monospace',
      ],
    },
    fontSize: {
      '3xs': '0.5rem',
      '2xs': '0.625rem',
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
      '6xl': '4rem',
      '7xl': '5rem',
      '8xl': '6rem',
    },
    fontWeight: {
      hairline: '100',
      thin: '200',
      light: '300',
      normal: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
      extrabold: '800',
      black: '900',
    },
    height: theme => ({
      auto: 'auto',
      ...theme('spacing'),
      full: '100%',
      screen: '100vh',
    }),
    inset: {
      '0': '0',
      auto: 'auto',
    },
    letterSpacing: {
      tighter: '-0.05em',
      tight: '-0.025em',
      normal: '0',
      wide: '0.025em',
      wider: '0.05em',
      widest: '0.1em',
    },
    lineHeight: {
      none: '1',
      tight: '1.25',
      snug: '1.375',
      normal: '1.5',
      relaxed: '1.625',
      loose: '2',
    },
    listStyleType: {
      none: 'none',
      disc: 'disc',
      decimal: 'decimal',
    },
    margin: (theme, { negative }) => ({
      auto: 'auto',
      ...theme('spacing'),
      ...negative(theme('spacing')),
    }),
    maxHeight: {
      full: '100%',
      screen: '100vh',
    },
    maxWidth: {
      xs: '20rem',
      sm: '24rem',
      md: '28rem',
      lg: '32rem',
      xl: '36rem',
      '2xl': '42rem',
      '3xl': '48rem',
      '4xl': '56rem',
      '5xl': '64rem',
      '6xl': '72rem',
      full: '100%',
    },
    minHeight: {
      '0': '0',
      full: '100%',
      screen: '100vh',
    },
    minWidth: {
      '0': '0',
      full: '100%',
    },
    objectPosition: {
      bottom: 'bottom',
      center: 'center',
      left: 'left',
      'left-bottom': 'left bottom',
      'left-top': 'left top',
      right: 'right',
      'right-bottom': 'right bottom',
      'right-top': 'right top',
      top: 'top',
    },
    opacity: {
      '0': '0',
      '25': '0.25',
      '50': '0.5',
      '75': '0.75',
      '100': '1',
    },
    order: {
      first: '-9999',
      last: '9999',
      none: '0',
      '1': '1',
      '2': '2',
      '3': '3',
      '4': '4',
      '5': '5',
      '6': '6',
      '7': '7',
      '8': '8',
      '9': '9',
      '10': '10',
      '11': '11',
      '12': '12',
    },
    padding: theme => theme('spacing'),
    stroke: {
      current: 'currentColor',
    },
    textColor: theme => theme('colors'),
    width: theme => ({
      auto: 'auto',
      ...theme('spacing'),
      '1/2': '50%',
      '1/3': '33.33333%',
      '2/3': '66.66667%',
      '1/4': '25%',
      '2/4': '50%',
      '3/4': '75%',
      '1/5': '20%',
      '2/5': '40%',
      '3/5': '60%',
      '4/5': '80%',
      '1/6': '16.66667%',
      '2/6': '33.33333%',
      '3/6': '50%',
      '4/6': '66.66667%',
      '5/6': '83.33333%',
      '1/12': '8.33333%',
      '2/12': '16.66667%',
      '3/12': '25%',
      '4/12': '33.33333%',
      '5/12': '41.66667%',
      '6/12': '50%',
      '7/12': '58.33333%',
      '8/12': '66.66667%',
      '9/12': '75%',
      '10/12': '83.33333%',
      '11/12': '91.66667%',
      full: '100%',
      screen: '100vw',
    }),
    zIndex: {
      auto: 'auto',
      '0': '0',
      '10': '10',
      '20': '20',
      '30': '30',
      '40': '40',
      '50': '50',
    },
  },
  variants: {
    alignContent: ['responsive'],
    alignItems: ['responsive'],
    alignSelf: ['responsive'],
    appearance: ['responsive'],
    backgroundAttachment: ['responsive'],
    backgroundColor: ['responsive', 'hover', 'focus'],
    backgroundPosition: ['responsive'],
    backgroundRepeat: ['responsive'],
    backgroundSize: ['responsive'],
    borderCollapse: ['responsive'],
    borderColor: ['responsive', 'hover', 'focus'],
    borderRadius: ['responsive'],
    borderStyle: ['responsive'],
    borderWidth: ['responsive'],
    boxShadow: ['responsive', 'hover', 'focus'],
    cursor: ['responsive'],
    display: ['responsive'],
    fill: ['responsive'],
    flex: ['responsive'],
    flexDirection: ['responsive'],
    flexGrow: ['responsive'],
    flexShrink: ['responsive'],
    flexWrap: ['responsive'],
    float: ['responsive'],
    fontFamily: ['responsive'],
    fontSize: ['responsive'],
    fontSmoothing: ['responsive'],
    fontStyle: ['responsive'],
    fontWeight: ['responsive', 'hover', 'focus'],
    height: ['responsive'],
    inset: ['responsive'],
    justifyContent: ['responsive'],
    letterSpacing: ['responsive'],
    lineHeight: ['responsive'],
    listStylePosition: ['responsive'],
    listStyleType: ['responsive'],
    margin: ['responsive'],
    maxHeight: ['responsive'],
    maxWidth: ['responsive'],
    minHeight: ['responsive'],
    minWidth: ['responsive'],
    objectFit: ['responsive'],
    objectPosition: ['responsive'],
    opacity: ['responsive'],
    order: ['responsive'],
    outline: ['responsive', 'focus'],
    overflow: ['responsive'],
    padding: ['responsive'],
    pointerEvents: ['responsive'],
    position: ['responsive'],
    resize: ['responsive'],
    stroke: ['responsive'],
    tableLayout: ['responsive'],
    textAlign: ['responsive'],
    textColor: ['responsive', 'hover', 'focus'],
    textDecoration: ['responsive', 'hover', 'focus'],
    textTransform: ['responsive'],
    userSelect: ['responsive'],
    verticalAlign: ['responsive'],
    visibility: ['responsive'],
    whitespace: ['responsive'],
    width: ['responsive'],
    wordBreak: ['responsive'],
    zIndex: ['responsive'],
  },
  corePlugins: {},
  plugins: [],
}
